// strona dashboardu

import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { reduxActions, useDispatch } from 'store';
import { PageTitle } from 'components/controls';
import { Deliveries, Payments, Summary, Orders } from 'pages/Dashboard/components';

import styles from 'theme/pages/Dashboard/Dashboard.module.scss';

const Dashboard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // ustawieni breadcrumbs'ów na starcie strony
  useEffect(() => {
    dispatch(reduxActions.setBreadcrumbs([{ name: t('Dashboard') }]));
  }, []);

  return (
    <div className={classnames(styles.componentWrapper, 'StylePath-Pages-Dashboard')}>
      <PageTitle title={t('Dashboard')} />
      <Grid container columnSpacing="32px">
        <Grid item xs={12}>
          <Summary />
          <Orders />
          <Payments />
          <Deliveries />
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
